{{ count < 100 ? count : ':)' }}
